<ng-container *ngIf="!isSubmissionDataLoading">
  <div
    *ngIf="!isOpportunitySelected"
    class="main-container padding-right-m"
    [autosave-module]="commonSectionFormModule"
  >
    <div
      class="header-container position-top-intake sticky-element-after-black-header padding-bottom-16 section-ending"
    >
      <div class="title-container align-items-center padding-bottom-16">
        <h4
          class="title text-align-left font-size-16 font-bold-700 padding-right-s"
          *ngIf="permissionObj['Intake_Submission_Title_Visible']"
        >
          {{ titleValue }}
        </h4>
        <div
          class="d-flex align-items-center"
          *ngIf="showPendingCloseoutActionSelect"
        >
          <div class="d-inline-block" *ngIf="isStatusPendingCloseout()">
            <div class="d-flex align-items-center w-fit-content">
              <img
                class="swap-icon"
                src="assets/images/dds-icons/swap-icon.svg"
              />

              <dds-dropdown
                class="custom-swap-dropdown"
                [theme]="swapButtonOptions.theme ?? _EMPTY"
                icon="dds-icon_arrow-down"
                [kind]="swapButtonOptions.kind ?? _EMPTY"
                [size]="swapButtonOptions.size ?? _EMPTY"
                [label]="selectedSwapAction"
                [ariaLabel]="selectedSwapAction"
                [width]="swapButtonOptions.width ?? _EMPTY"
                [isInverse]="swapButtonOptions.isInverse ?? false"
                [isColorBg]="swapButtonOptions.isColorBg ?? false"
                [disabled]="swapButtonOptions.disabled ?? false"
                [isResponsive]="swapButtonOptions.isResponsive ?? false"
                [stickerWidth]="swapButtonOptions.stickerWidth ?? _EMPTY"
                [stickerIsOutsideClick]="
                  swapButtonOptions.stickerIsOutsideClick ?? false
                "
                [stickerIndent]="swapButtonOptions.stickerIndent ?? 0"
                [stickerCustomClass]="
                  swapButtonOptions.stickerCustomClass ?? _EMPTY
                "
                [stickerIsDynamic]="swapButtonOptions.stickerIsDynamic ?? false"
                (itemSelected)="swapSectionSelected($event)"
                #swapDropdown
              >
                <dds-dropdown-item
                  *ngFor="let item of swapSectionOptions; trackBy: trackByValue"
                  [value]="item.value"
                  >{{ item.heading }}</dds-dropdown-item
                >
              </dds-dropdown>
            </div>
          </div>

          <ng-container *ngIf="isSelfReviewButtonVisible">
            <dds-button
              class="custom-button margin-left-xs"
              [theme]="selfReviewBtnOption.theme ?? _EMPTY"
              [kind]="selfReviewBtnOption.kind ?? _EMPTY"
              [size]="selfReviewBtnOption.size ?? _EMPTY"
              [width]="selfReviewBtnOption.width ?? _EMPTY"
              [icon]="selfReviewBtnOption.icon ?? _EMPTY"
              [isIconLeft]="selfReviewBtnOption.isIconLeft ?? false"
              [role]="selfReviewBtnOption.role ?? _EMPTY"
              [isInverse]="selfReviewBtnOption.isInverse ?? false"
              [isColorBg]="selfReviewBtnOption.isColorBg ?? false"
              [isLoading]="selfReviewBtnOption.isLoading ?? false"
              [ariaLabel]="selfReviewBtnLabel"
              [customClass]="selfReviewBtnOption.customClass ?? _EMPTY"
              [disabled]="
                updateSubmitButtonStatus() || !isOpporunityLevelFormCompleted
              "
              (clicked)="onclickSelfReviewBtn()"
              ><span>{{ selfReviewBtnLabel }}</span></dds-button
            >
            <dds-button
              class="custom-button margin-left-xs"
              [theme]="optOutOfSelfReviewBtnOption.theme ?? _EMPTY"
              [kind]="optOutOfSelfReviewBtnOption.kind ?? _EMPTY"
              [size]="optOutOfSelfReviewBtnOption.size ?? _EMPTY"
              [width]="optOutOfSelfReviewBtnOption.width ?? _EMPTY"
              [icon]="optOutOfSelfReviewBtnOption.icon ?? _EMPTY"
              [isIconLeft]="optOutOfSelfReviewBtnOption.isIconLeft ?? false"
              [role]="optOutOfSelfReviewBtnOption.role ?? _EMPTY"
              [isInverse]="optOutOfSelfReviewBtnOption.isInverse ?? false"
              [isColorBg]="optOutOfSelfReviewBtnOption.isColorBg ?? false"
              [isLoading]="optOutOfSelfReviewBtnOption.isLoading ?? false"
              [ariaLabel]="optOutOfSelfReviewBtnLabel"
              [customClass]="optOutOfSelfReviewBtnOption.customClass ?? _EMPTY"
              [disabled]="
                updateSubmitButtonStatus() || !isOpporunityLevelFormCompleted
              "
              (clicked)="onclickOptOutOfSelfReviewBtn()"
              ><span>{{ optOutOfSelfReviewBtnLabel }}</span></dds-button
            >
          </ng-container>
          <dds-button
            *ngIf="isSubmitBtnVisible()"
            class="custom-button"
            [theme]="submitButtonOptions.theme ?? _EMPTY"
            [kind]="submitButtonOptions.kind ?? _EMPTY"
            [size]="submitButtonOptions.size ?? _EMPTY"
            [width]="submitButtonOptions.width ?? _EMPTY"
            [icon]="submitButtonOptions.icon ?? _EMPTY"
            [isIconLeft]="submitButtonOptions.isIconLeft ?? false"
            [role]="submitButtonOptions.role ?? _EMPTY"
            [isInverse]="submitButtonOptions.isInverse ?? false"
            [isColorBg]="submitButtonOptions.isColorBg ?? false"
            [isLoading]="submitButtonOptions.isLoading ?? false"
            [ariaLabel]="submitLabel"
            [customClass]="submitButtonOptions.customClass ?? _EMPTY"
            [disabled]="
              !permissionObj['Intake_Submission_SubmitBtn_Enable'] ||
              updateSubmitButtonStatus() ||
              allDocTypeSelectedIsSupporting ||
              !isOpporunityLevelFormCompleted
            "
            (clicked)="submitCommonSectionData(submissionStatusSubmitted)"
            ><span>{{ submitLabel }}</span></dds-button
          >

          <dds-button
            *ngIf="isArchiveAndCompleteBtnVisible()"
            class="custom-button margin-left-xs"
            [theme]="archiveAndCompleteBtnOption.theme ?? _EMPTY"
            [kind]="archiveAndCompleteBtnOption.kind ?? _EMPTY"
            [size]="archiveAndCompleteBtnOption.size ?? _EMPTY"
            [width]="archiveAndCompleteBtnOption.width ?? _EMPTY"
            [icon]="archiveAndCompleteBtnOption.icon ?? _EMPTY"
            [isIconLeft]="archiveAndCompleteBtnOption.isIconLeft ?? false"
            [role]="archiveAndCompleteBtnOption.role ?? _EMPTY"
            [isInverse]="archiveAndCompleteBtnOption.isInverse ?? false"
            [isColorBg]="archiveAndCompleteBtnOption.isColorBg ?? false"
            [isLoading]="archiveAndCompleteBtnOption.isLoading ?? false"
            [ariaLabel]="archiveAndCompleteBtnLabel"
            [customClass]="archiveAndCompleteBtnOption.customClass ?? _EMPTY"
            [disabled]="
              !permissionObj[
                'Intake_Submission_ArchiveAndCompleteBtn_Enable'
              ] ||
              isArchiveAndCompleteBtnDisabled ||
              !isOpporunityLevelFormCompleted
            "
            (clicked)="onclickArchiveAndCompleteBtn()"
            ><span>{{ archiveAndCompleteBtnLabel }}</span></dds-button
          >

          <dds-button
            *ngIf="isResubmitBtnVisible() && !isSelfReviewButtonVisible"
            class="custom-button"
            [theme]="submitButtonOptions.theme ?? _EMPTY"
            [kind]="submitButtonOptions.kind ?? _EMPTY"
            [size]="submitButtonOptions.size ?? _EMPTY"
            [width]="submitButtonOptions.width ?? _EMPTY"
            [icon]="submitButtonOptions.icon ?? _EMPTY"
            [isIconLeft]="submitButtonOptions.isIconLeft ?? false"
            [role]="submitButtonOptions.role ?? _EMPTY"
            [isInverse]="submitButtonOptions.isInverse ?? false"
            [isColorBg]="submitButtonOptions.isColorBg ?? false"
            [isLoading]="submitButtonOptions.isLoading ?? false"
            [ariaLabel]="'Resubmit'"
            [customClass]="submitButtonOptions.customClass ?? _EMPTY"
            [disabled]="
              !permissionObj['Intake_Submission_ReSubmitBtn_Enable'] ||
              updateSubmitButtonStatus() ||
              !isOpporunityLevelFormCompleted
            "
            (clicked)="resubmitCommonSectionData()"
            ><span>Resubmit</span></dds-button
          >

          <!-- TODO: Showing and hiding of the buttons to be implemented once we have the employee id -->
          <ng-container *ngIf="showReviewAndReturnBtn">
            <dds-button
              *ngIf="
                permissionObj['Intake_Submission_CompleteReviewBtn_Visible'] &&
                showReviewBtn
              "
              class="custom-button padding-right-xs"
              [disabled]="
                !permissionObj['Intake_Submission_CompleteReviewBtn_Enable'] ||
                !isOpporunityLevelFormCompleted
              "
              (clicked)="handleCompleteReviewFromHeader()"
              >Complete review</dds-button
            >
            <dds-button
              *ngIf="
                permissionObj['Intake_Submission_ReturnForReworkBtn_Visible']
              "
              class="custom-button"
              [kind]="primaryButtonOptions.kind ?? _EMPTY"
              [disabled]="
                !permissionObj['Intake_Submission_ReturnForReworkBtn_Enable'] ||
                !isOpporunityLevelFormCompleted
              "
              (clicked)="handleReturnForReworkFromHeader()"
              >Return for revisions</dds-button
            >
          </ng-container>
        </div>
      </div>
      <div class="sub-header">
        <div
          *ngIf="
            permissionObj['Intake_Submission_SubmissionType_Visible'] &&
            submissionTypeCode
          "
          class="submission-type font-size-12 font-bold-600 line-height-s width-padding"
        >
          {{ submissionTypeCode }}
        </div>
        <div
          *ngIf="
            permissionObj['Intake_Submission_SubmissionStatus_Visible'] &&
            submissionStatus
          "
          [style.color]="
            transformStatusStyle(submissionStatus) | statusStyle : 'color'
          "
          [style.backgroundColor]="
            transformStatusStyle(submissionStatus)
              | statusStyle : 'backgroundColor'
          "
          class="custom-pad margin-left-xxs font-size-12 font-bold-600 line-height-s"
        >
          {{ submissionStatus }}
        </div>
        <div
          class="id-container eclipse-content"
          *ngIf="permissionObj['Intake_Submission_SubmissionId_Visible']"
        >
          <ng-container *ngIf="submissionId && submissionId != 0">
            <span class="id-title">ID:</span>
            <span #textToCopy class="eclipse-content">{{ submissionId }}</span>
            <span
              class="dds-icon dds-icon_copy__l__stroke icon relative"
              (click)="copyToClipboard(textToCopy.textContent)"
            ></span>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        showPendingCloseoutActionSelect;
        else swapActionSelectionForPendingCloseout
      "
    >
      <ng-container
        *ngIf="
          submissionStatus !== submissionStatusRMPendingCloseout &&
            submissionStatus !== submissionStatusSelfPendingCloseout &&
            submissionStatus !== submissionStatusIncompletePendingCloseout;
          else pendingCloseoutScreen
        "
      >
        <div
          *ngIf="
            coHasParentOpportunityNumber &&
            permissionObj['Intake_Submission_ELSOWOpportunityID_Visible']
          "
          class="search-elsow-section section-ending"
        >
          <app-search-elsow
            [permissionObj]="permissionObj"
            [dgmfId]="primaryDgmfId"
            [gmdmId]="primaryGmdmId"
            [swiftId]="primarySwiftId"
            [coOppDonotMatchMessage]="coOppDonotMatchMessage"
            [opportunityNumber]="opportunityNumber"
            [submissionId]="submissionId"
          ></app-search-elsow>
        </div>

        <dds-accordion [isMulti]="true">
          <dds-accordion-item
            *ngIf="
              isAccordionVisible(submissionTypeCodeCO) &&
              permissionObj['Intake_Submission_ChangeOrder_Visible']
            "
            [isOpen]="isCOAccordionOpen() || collapseAccordion"
          >
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Change Order</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="COSpecificSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item [isOpen]="collapseSelfReviewAccordion">
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header"
                  >Self-review eligibility</span
                >
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="SelfReviewSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item
            *ngIf="
              isAccordionVisible(submissionTypeCodePro) &&
              permissionObj['Intake_Submission_Proposal_Visible']
            "
            [isOpen]="isProposalAccordionOpen()"
          >
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Proposal</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="ProposalSpecificSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item
            *ngIf="
              isAccordionVisible(submissionTypeCodeDelivery) &&
              permissionObj['Intake_Submission_Deliverable_Visible']
            "
            [isOpen]="isDeliverableAccordionOpen() || collapseAccordion"
          >
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Deliverable</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="DeliverableSpecificSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item
            *ngIf="
              isAccordionVisible(submissionTypeCodeOther) &&
              permissionObj['Intake_Submission_Other_Visible']
            "
            [isOpen]="isOtherAccordionOpen() || collapseAccordion"
          >
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Submission details</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="OtherSpecificSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item [isOpen]="true">
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Documents</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>

            <span content>
              <div class="accordion-content">
                <div *ngIf="isSelfReviewButtonVisible" class="styled-box-green">
                  <img
                    src="\assets\images\green-pin-icon.svg"
                    alt="lock-icon"
                  />
                  {{ selfReviewDocBanner }}
                </div>

                <ng-container
                  *ngIf="
                    permissionObj['Intake_Submission_LEPConfirmation_Visible']
                  "
                >
                  <div class="styled-box d-flex" *ngIf="!pursuitLeaderId">
                    <span class="lep-message-padding">
                      LEP not assigned on Opportunity details
                    </span>
                  </div>
                  <div
                    *ngIf="showLepConfirmationMessage; else showLEPMessage"
                    class="styled-box d-flex"
                  >
                    <span class="lep-message-padding">
                      Confirm that
                      {{ pursuitLeaderName !== null ? pursuitLeaderName : "" }}
                      has completed the review of document(s) prior to
                      submission for Risk Management review.
                    </span>
                    <dds-button
                      class="button"
                      [disabled]="
                        !permissionObj[
                          'Intake_Submission_LEPConfirmation_Enable'
                        ] || !pursuitLeaderId
                      "
                      (clicked)="handleLEPCompletion()"
                      >Confirm LEP review completion</dds-button
                    >
                  </div>
                  <ng-template #showLEPMessage>
                    <div>
                      <div
                        class="comments-text-label eclipse-small-header-grey font-size-11"
                      >
                        LEP review:
                      </div>
                      <div class="col-12">
                        <p class="margin-bottom-none">
                          Acknowledged by {{ lepAcknowledgedBy }}
                          {{ lepAcknowledgementDate }}
                        </p>
                        <p>
                          that {{ lepReviewedBy }} has reviewed the document(s)
                          being submitted for review.
                        </p>
                      </div>
                      <div
                        *ngIf="!isValidDocumentUploaded"
                        class="styled-box-3"
                      >
                        {{ configLableDocument }}
                      </div>
                    </div>
                  </ng-template>
                </ng-container>

                <div *ngIf="!showLepConfirmationMessage">
                  <ng-container
                    *ngTemplateOutlet="
                      documentComponentTemplate;
                      context: {
                        $implicit: {
                          opportunityDocs: opportunityDocs,
                          isDocSectionEditable:
                            !isSubmissionInReadOnlyStatus() &&
                            !isLoggedInUserOnlyEngagementTeamMember(),
                          tableId: tableIdMapper['NonPendingCloseoutTable'],
                          showArchiveColumn:
                            isSubmissionInCompletedOrAdminComplete()
                        }
                      }
                    "
                  ></ng-container>
                </div>
                <div
                  class="row"
                  *ngIf="isAccordionVisible(submissionTypeCodeDelivery)"
                >
                  <div class="col-12">
                    <div class="sub-text-section relative">
                      <span class="icon-s icon-pinned"></span>
                      <span>
                        <div class="text-label font-bold-600">
                          The LEP is ultimately responsible for the quality and
                          risk assessment regarding the deliverable.
                        </div>
                        <div
                          class="vertical-line-green absolute"
                          *ngIf="isShowMoreDocumentNotes"
                        ></div>
                      </span>
                    </div>
                    <div class="padding-left-s">
                      <span>
                        <div
                          class="margin-top-xs text-gray"
                          *ngIf="isShowMoreDocumentNotes"
                        >
                          <div class="padding-bottom-s">
                            Deliverables requiring Risk Manager review may be
                            submitted.
                          </div>
                          <ul>
                            <li class="padding-bottom-s">
                              <div
                                class="submission-type font-size-12 font-bold-600 line-height-s"
                              >
                                Sufficient documentation:
                              </div>
                              Prepare and maintain sufficient documentation to
                              support the results or information in the report
                              or deliverables.
                            </li>
                            <li class="padding-bottom-s">
                              <div
                                class="submission-type font-size-12 font-bold-600 line-height-s"
                              >
                                Primary and overriding reviews:
                              </div>
                              Conduct reviews of supporting documentation before
                              submitting deliverables for Risk Manager review.
                            </li>
                            <li class="padding-bottom-s">
                              <div
                                class="submission-type font-size-12 font-bold-600 line-height-s"
                              >
                                Deliverable modification consultation:
                              </div>
                              Consult with the Risk Manager if (i) the client or
                              their advisor disputes our findings, or (ii) The
                              client requests changes that could soften or
                              diminish our findings.
                            </li>
                          </ul>
                        </div>
                      </span>
                      <dds-button
                        class="showMoreCls"
                        [theme]="showMoreOptions.theme ?? _EMPTY"
                        [kind]="showMoreOptions.kind ?? _EMPTY"
                        [size]="showMoreOptions.size ?? _EMPTY"
                        [width]="showMoreOptions.width ?? _EMPTY"
                        [icon]="showMoreOptions.icon ?? _EMPTY"
                        [isIconLeft]="showMoreOptions.isIconLeft ?? false"
                        [role]="showMoreOptions.role ?? _EMPTY"
                        [ariaLabel]="showMoreOptions.ariaLabel ?? _EMPTY"
                        [customClass]="showMoreOptions.customClass ?? _EMPTY"
                        (clicked)="clickToShowDocumentMoreLepMessage()"
                        >{{ showMoreText }}</dds-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </dds-accordion-item>

          <dds-accordion-item [isOpen]="true">
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Notes/Feedback</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="NotesFeedbackSection"
              ></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item
            [isOpen]="!isSelfReviewButtonVisible || collapseAccordion"
          >
            <span header class="accordion-header">
              <div class="section-header">
                <span class="eclipse-section-header">Workflow</span>
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container *ngTemplateOutlet="WorkflowSection"></ng-container>
            </span>
          </dds-accordion-item>

          <dds-accordion-item *ngIf="isInternalQRMVisible" [isOpen]="true">
            <span header class="accordion-header">
              <div class="section-header margin-bottom-s">
                <span class="eclipse-section-header"
                  >Internal QRM team communication</span
                >
              </div>
            </span>
            <dds-list-item header [isClickable]="false" [hasBorder]="false">
            </dds-list-item>
            <span content>
              <ng-container
                *ngTemplateOutlet="InternalQRMSection"
              ></ng-container>
            </span>
          </dds-accordion-item>
        </dds-accordion>
      </ng-container>

      <ng-template #pendingCloseoutScreen>
        <ng-container *ngIf="selectedSwapAction === swapReviewedDocResubmit">
          <ng-container
            *ngIf="submissionStatus === submissionStatusRMPendingCloseout"
          >
            <div
              class="sub-text-section text-cool-gray margin-top-sm margin-bottom-sm"
            >
              <div class="d-flex flex-column">
                <span class="icon-s icon-pinned"></span>
                <div
                  class="d-block vertical-line-green-without-title relative"
                ></div>
              </div>
              <ul
                class="font-size-14 font-bold-400 line-height-sm padding-left-m text-align-left mb-0"
              >
                <li>
                  To download reviewed document(s) go to the 'Access reviewed
                  documents' section.
                </li>
                <li>
                  To re-submit document(s) for review by a Risk Manager, go to
                  the 'Resubmit documents' section.
                </li>
              </ul>
            </div>
            <div class="section-ending"></div>
          </ng-container>

          <dds-accordion [isMulti]="true">
            <dds-accordion-item
              *ngIf="submissionStatus === submissionStatusRMPendingCloseout"
              [isOpen]="true"
              class="accordion-item-pending-closeout"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header"
                    >Access reviewed documents</span
                  >
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <div class="accordion-content">
                  <div class="styled-box-2">
                    {{ pendingCloseOutNonSelfReviewMsg }}
                  </div>
                  <div
                    *ngIf="
                      permissionObj[
                        'Intake_Submission_NotesAndFeedback_Visible'
                      ]
                    "
                    class="margin-bottom-m"
                  >
                    <p class="font-bold-600 margin-bottom-es">Notes/Feedback</p>
                    <dds-input
                      autosave
                      class="notes-feedback"
                      [placeholder]="enter_text_placeholder"
                      [(ngModel)]="model.notesAndFeedback"
                      [disabled]="
                        !permissionObj[
                          'Intake_Submission_NotesAndFeedback_Enable'
                        ]
                      "
                    >
                    </dds-input>
                  </div>

                  <div class="margin-bottom-m">
                    <p class="font-bold-600 margin-bottom-es">Documents</p>
                    <ng-container
                      *ngTemplateOutlet="
                        documentComponentTemplate;
                        context: {
                          $implicit: {
                            tableId: tableIdMapper['AccessReviewedTable'],
                            opportunityDocs: opportunityDocs,
                            isDocSectionEditable: false,
                            showDragNDropArea: false,
                            showAddLinkBtn: false,
                            showToggleBtn: true,
                            toggleOpen: true,
                            filterDocArr: reviewedDocStatusArr,
                          }
                        }
                      "
                    ></ng-container>
                  </div>

                  <dds-button
                    class="custom-button"
                    [theme]="primaryButtonOptions.theme ?? _EMPTY"
                    [kind]="primaryButtonOptions.kind ?? _EMPTY"
                    [size]="primaryButtonOptions.size ?? _EMPTY"
                    [width]="primaryButtonOptions.width ?? _EMPTY"
                    ariaLabel="Return to Dashboard"
                    [routerLink]="['/']"
                    >Return to Dashboard</dds-button
                  >
                </div></span
              >
            </dds-accordion-item>

            <dds-accordion-item
              [isOpen]="true"
              class="accordion-item-pending-closeout"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header"
                    >Resubmit for review</span
                  >
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <div class="accordion-content">
                  <div class="sub-text-section text-cool-gray margin-bottom-sm">
                    <span class="icon-s icon-pinned"></span>
                    <div>
                      Upload the draft document(s) for risk management review.
                    </div>
                  </div>

                  <div class="margin-bottom-m">
                    <div class="d-flex align-items-center gap-1">
                      <!-- TODO: Add document length check - if > 0 and reason === 0-->
                      <img
                        *ngIf="isResubmitReasonIndicatorVisible"
                        src="\assets\images\draftIcon.svg"
                      />
                      <span class="font-bold-600">
                        Reason for resubmitting document(s) for review
                      </span>
                    </div>

                    <dds-input
                      autosave
                      class="notes-feedback"
                      [(ngModel)]="model.reasonForResubmit"
                      [placeholder]="enter_text_placeholder"
                      [min]="15"
                      [max]="10000"
                      descriptionType="text"
                      description="Minimum 15 characters"
                      (valueChanged)="checkValidation()"
                      #resubmitReasonInput
                    >
                    </dds-input>
                  </div>

                  <div class="margin-bottom-m">
                    <p class="font-bold-600 mb-0">Documents</p>
                    <ng-container
                      *ngTemplateOutlet="
                        documentComponentTemplate;
                        context: {
                          $implicit: {
                            tableId: tableIdMapper['ResubmitTable'],
                            opportunityDocs: opportunityDocs,
                            isDocSectionEditable: true,
                            showToggleBtn: false,
                            filterDocArr: resubmitDraftDocStatusArr,
                          }
                        }
                      "
                    ></ng-container>
                  </div>

                  <!--Add resubmit disable based on doc and reason field-->
                  <dds-button
                    *ngIf="
                      this.permissionObj[
                        'Intake_Submission_ReSubmitBtn_Visible'
                      ]
                    "
                    class="custom-button"
                    [theme]="primaryLoudButtonOptions.theme ?? _EMPTY"
                    [kind]="primaryLoudButtonOptions.kind ?? _EMPTY"
                    [size]="primaryLoudButtonOptions.size ?? _EMPTY"
                    [width]="primaryLoudButtonOptions.width ?? _EMPTY"
                    [ariaLabel]="reSubmitForReviewLabel"
                    [disabled]="isResubmitBtnDisabled"
                    (clicked)="onclickResubmitForReviewBtn()"
                    >{{ reSubmitForReviewLabel }}</dds-button
                  >
                </div></span
              >
            </dds-accordion-item>
          </dds-accordion>
        </ng-container>
        <ng-container *ngIf="selectedSwapAction === swapArchiveFinalize">
          <dds-accordion [isMulti]="true">
            <dds-accordion-item [isOpen]="true">
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header"
                    >Archive document(s)</span
                  >
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <div class="accordion-content">
                  <app-wbs-charge-code
                    *ngIf="submissionTypeCode !== submissionTypeCodePro"
                    [wbsChargeCode]="model.wbsChargeCode ?? _EMPTY"
                    [wbsDescription]="model.wbsDescription ?? _EMPTY"
                    [dataSubmissionId]="dataSubmissionId"
                    [dataOpportunityId]="dataOpportunityId"
                    [archiveDetails]="archiveDetails"
                    [swiftDetails]="swiftDetails"
                    [permissionObj]="permissionObj"
                    [wbsPendingCheckbox]="model?.isWBSPending ?? false"
                    (wbsOrArchiveChange)="onWbsOrArchiveChange($event)"
                  />

                  <div
                    *ngIf="showArchiveReadyDocNote"
                    class="sub-text-section text-cool-gray margin-top-m"
                  >
                    <span class="icon-s icon-pinned"></span>
                    <div>
                      All documents with an "Archive ready" status will move to
                      Archive It.
                    </div>
                  </div>

                  <div
                    *ngIf="isFinalDocumentAcceptedMsgShow"
                    class="styled-box margin-top-vs"
                  >
                    <span
                      *ngIf="
                        submissionTypeCode === submissionTypeCodePro ||
                        submissionTypeCode === submissionTypeCodeDelivery
                      "
                    >
                      Upload the final document presented to/accepted by the
                      client
                    </span>
                    <span *ngIf="submissionTypeCode === submissionTypeCodeOther"
                      >Upload the final version of the document</span
                    >
                    <span
                      *ngIf="
                        submissionTypeCode === submissionTypeCodeCO ||
                        submissionTypeCode === submissionTypeCodeELSOW
                      "
                      >Upload the executed version of the Engagement
                      Letter/Statement of Work or Change Order.</span
                    >
                  </div>

                  <!-- TODO: Check if this exist for archive screen -->
                  <div *ngIf="showAdditionalRMDocMsg">
                    <div class="styled-box mb-0">
                      <span
                        >Upload the updated document that requires additional
                        Risk Manager review</span
                      >
                    </div>
                  </div>

                  <ng-container *ngIf="!isArchiveReadyDocPresent">
                    <ng-container
                      *ngTemplateOutlet="
                      documentComponentTemplate;
                      context: {
                        $implicit: {
                          tableId: tableIdMapper['ArchiveFinalizeTable'],
                          opportunityDocs: opportunityDocs,
                          isDocSectionEditable: true,
                          showDragNDropArea: true,
                          showAddLinkBtn: false,
                          showDocumentTable: false,
                        }
                      }
                    "
                    ></ng-container
                  ></ng-container>
                </div>
              </span>
            </dds-accordion-item>

            <dds-accordion-item [isOpen]="isArchiveReadyDocPresent">
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Documents</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <div class="accordion-content">
                  <ng-container
                    *ngTemplateOutlet="
                      documentComponentTemplate;
                      context: {
                        $implicit: {
                          tableId: tableIdMapper['AllDocTable'],
                          opportunityDocs: opportunityDocs,
                          isDocSectionEditable: true,
                          showDragNDropArea: false,
                          showAddLinkBtn: false,
                          showDocumentTable: true,
                          showArchiveColumn: true,
                          toggleOpen: true,
                          
                        }
                      }
                    "
                  ></ng-container></div
              ></span>
            </dds-accordion-item>

            <dds-accordion-item [isOpen]="false">
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Notes/Feedback</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="NotesFeedbackSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item [isOpen]="false">
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header"
                    >Self-review eligibility</span
                  >
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="SelfReviewSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item
              *ngIf="
                isAccordionVisible(submissionTypeCodePro) &&
                permissionObj['Intake_Submission_Proposal_Visible']
              "
              [isOpen]="false"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Proposal</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="ProposalSpecificSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item
              *ngIf="
                isAccordionVisible(submissionTypeCodeCO) &&
                permissionObj['Intake_Submission_ChangeOrder_Visible']
              "
              [isOpen]="false"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Change Order</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="COSpecificSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item
              *ngIf="
                isAccordionVisible(submissionTypeCodeDelivery) &&
                permissionObj['Intake_Submission_Deliverable_Visible']
              "
              [isOpen]="false"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Deliverable</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="DeliverableSpecificSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item
              *ngIf="
                isAccordionVisible(submissionTypeCodeOther) &&
                permissionObj['Intake_Submission_Other_Visible']
              "
              [isOpen]="false"
            >
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Submission details</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="OtherSpecificSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item [isOpen]="false">
              <span header class="accordion-header">
                <div class="section-header">
                  <span class="eclipse-section-header">Workflow</span>
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="WorkflowSection"
                ></ng-container>
              </span>
            </dds-accordion-item>

            <dds-accordion-item *ngIf="isInternalQRMVisible" [isOpen]="false">
              <span header class="accordion-header">
                <div class="section-header margin-bottom-s">
                  <span class="eclipse-section-header"
                    >Internal QRM team communication</span
                  >
                </div>
              </span>
              <dds-list-item header [isClickable]="false" [hasBorder]="false">
              </dds-list-item>
              <span content>
                <ng-container
                  *ngTemplateOutlet="InternalQRMSection"
                ></ng-container>
              </span>
            </dds-accordion-item>
          </dds-accordion>
        </ng-container>
      </ng-template>
    </ng-container>

    <ng-template #COSpecificSection>
      <div class="accordion-content">
        <div>
          <div class="row">
            <div>
              <span
                *ngIf="!model.coChangeScope"
                class="icon-required-yellow"
              ></span>
              <span>{{ COChangeScope_radioGroupOptions.title }}</span>
            </div>

            <div class="col-12">
              <div class="textarea-container">
                <div class="row padding-top-xs">
                  <div class="col-12">
                    <dds-radio-group
                      autosave
                      [disabled]="
                        isSubmissionInReadOnlyStatus() ||
                        !permissionObj['Intake_Submission_ChangeOrder_Enable']
                      "
                      [(ngModel)]="model.coChangeScope"
                      [name]="COChangeScope_radioGroupOptions.name"
                      [isUncheckable]="
                        COChangeScope_radioGroupOptions.isUncheckable
                      "
                      [isRequired]="COChangeScope_radioGroupOptions.isRequired"
                      [errorState]="COChangeScope_radioGroupOptions.errorState"
                      (stateChanged)="stateHandling()"
                    >
                      <div class="d-flex">
                        <ng-container
                          *ngFor="let radio of COChangeScope_radio_values"
                        >
                          <dds-radio
                            [value]="radio.value"
                            [customClass]="
                              'padding-right-half-rem padding-right-vs'
                            "
                            [label]="radio.options.label"
                            [theme]="radio.options.theme"
                          ></dds-radio>
                          <br />
                        </ng-container>
                      </div>
                    </dds-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div>
              <span
                *ngIf="!model.coDescription && !disableFieldOnComplete()"
                class="icon-required-yellow"
              ></span>
              <span>Provide Change Order description</span>
            </div>

            <div class="col-12">
              <div class="textarea-container">
                <div class="row padding-top-xs">
                  <div class="col-12">
                    <dds-textarea
                      autosave
                      name="coDescription"
                      [(ngModel)]="model.coDescription"
                      [label]="textareaOptions.label"
                      [labelPosition]="textareaOptions.labelPosition"
                      [placeholder]="textareaOptions.placeholder"
                      [description]="textareaOptions.description"
                      [minHeight]="textareaOptions.minHeight"
                      [isRequired]="textareaOptions.isRequired"
                      [customClass]="textareaOptions.customClass"
                      [isError]="textareaOptions.isError"
                      [errorMessage]="textareaOptions.errorMessage"
                      [errorState]="textareaOptions.errorState"
                      [maxLength]="textareaOptions.maxLength"
                      [readonly]="
                        isSubmissionInReadOnlyStatus() ||
                        !permissionObj['Intake_Submission_ChangeOrder_Enable']
                      "
                      [maxLengthPosition]="textareaOptions.maxLengthPosition"
                      [size]="textareaOptions.size"
                      (valueChanged)="CODescriptionValueChanged()"
                    ></dds-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #SelfReviewSection>
      <div class="accordion-content">
        <div class="accordion-container">
          <div
            class="self-review-div"
            *ngIf="
              permissionObj['Intake_Submission_EligibleForSelfReview_Visible']
            "
          >
            <div
              class="comments-text-label eclipse-small-header-grey font-size-11"
            >
              Eligible for self-review
            </div>
            <div class="value-font">
              {{ selfReviewEligibility }}
            </div>
          </div>
          <div
            class="submission-title-container self-review-div"
            *ngIf="permissionObj['Intake_Submission_SubmissionTitle_Visible']"
          >
            <div class="d-flex align-items-center">
              <span
                *ngIf="!model.submissionTitle"
                class="icon-required-yellow"
              ></span>
              <div
                class="comments-text-label eclipse-small-header-grey font-size-11"
              >
                Submission title
              </div>
            </div>

            <div class="input-container" (click)="$event.stopPropagation()">
              <ng-container *ngIf="isEditingTitle; else displayTitle">
                <div class="col-12">
                  <dds-input
                    autosave
                    [placeholder]="enter_text_placeholder"
                    [(ngModel)]="model.submissionTitle"
                    id="title-editor"
                  >
                  </dds-input>
                </div>
              </ng-container>
              <ng-template #displayTitle>
                <span class="title-value value-font">{{ titleValue }}</span>
                <span
                  *ngIf="
                    !isSubmissionInReadOnlyStatus() &&
                    permissionObj['Intake_Submission_SubmissionTitle_Enable']
                  "
                  class="dds-icon dds-icon_edit__s__filled edit-icon"
                  (click)="editTitle()"
                ></span>
              </ng-template>
            </div>
          </div>
          <div *ngIf="optOutOfSelfReviewReason" class="self-review-div">
            <div
              class="comments-text-label eclipse-small-header-grey font-size-11"
            >
              Reason for opt-out self-review:
            </div>
            <div>
              {{ optOutOfSelfReviewReason }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #OtherSpecificSection>
      <div class="accordion-content">
        <div class="row">
          <div>
            <span
              *ngIf="!model.otherDescription"
              class="icon-required-yellow"
            ></span>
            <span>Submission description</span>
          </div>

          <div class="col-12">
            <div class="textarea-container">
              <div class="row padding-top-xs">
                <div class="col-12">
                  <dds-textarea
                    autosave
                    name="otherDescription"
                    [disabled]="disableFieldOnComplete()"
                    [(ngModel)]="model.otherDescription"
                    [label]="textareaOptions.label"
                    [labelPosition]="textareaOptions.labelPosition"
                    [placeholder]="textareaOptions.placeholder"
                    [description]="textareaOptions.description"
                    [minHeight]="textareaOptions.minHeight"
                    [isRequired]="textareaOptions.isRequired"
                    [customClass]="textareaOptions.customClass"
                    [isError]="textareaOptions.isError"
                    [errorMessage]="textareaOptions.errorMessage"
                    [errorState]="textareaOptions.errorState"
                    [maxLength]="textareaOptions.maxLength"
                    [maxLengthPosition]="textareaOptions.maxLengthPosition"
                    [size]="textareaOptions.size"
                    [readonly]="
                      isSubmissionInReadOnlyStatus() ||
                      !permissionObj['Intake_Submission_Other_Enable']
                    "
                    (valueChanged)="OtherDescriptionValueChanged()"
                  ></dds-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="others-subtype">
          <div>
            <span
              *ngIf="!model.submissionSubTypeId && !disableFieldOnComplete()"
              class="icon-required-yellow"
            ></span>
            <span class="eclipse-small-header-grey font-size-11">{{
              other_subtype_radioGroupOptions.title
            }}</span>
          </div>
          <div class="value-font" *ngIf="otherSubTypes$ | async">
            {{ getSubmissionSubType(model.submissionSubTypeId) }}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #ProposalSpecificSection>
      <div class="accordion-content">
        <div class="row">
          <div>
            <span
              *ngIf="!model.relatedToRFP && !disableFieldOnComplete()"
              class="icon-required-yellow"
            ></span>
            <span>{{ RFP_radioGroupOptions.title }}</span>
            <div *ngIf="model.relatedToRFP === 'yes'" class="sub-text-section">
              <span
                class="icon-s icon-pinned margin-right-xs margin-top-xxs"
              ></span>
              <span
                class="text-label eclipse-content-grey"
                [innerHTML]="uploadDocNote"
              ></span>
            </div>
          </div>

          <div class="col-12">
            <div class="textarea-container">
              <div class="row padding-top-xs">
                <div class="col-12">
                  <dds-radio-group
                    autosave
                    [disabled]="disableFieldOnComplete()"
                    [(ngModel)]="model.relatedToRFP"
                    [name]="RFP_radioGroupOptions.name"
                    [isUncheckable]="RFP_radioGroupOptions.isUncheckable"
                    [isRequired]="RFP_radioGroupOptions.isRequired"
                    [errorState]="RFP_radioGroupOptions.errorState"
                    (stateChanged)="RelatedtoRFPstateChanged()"
                    [disabled]="
                      isSubmissionInReadOnlyStatus() ||
                      !permissionObj['Intake_Submission_Proposal_Enable']
                    "
                  >
                    <ng-container *ngFor="let radio of REP_radio_values">
                      <dds-radio
                        [value]="radio.value"
                        [label]="radio.options.label"
                        [theme]="radio.options.theme"
                      ></dds-radio>
                      <br />
                    </ng-container>
                  </dds-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #DeliverableSpecificSection>
      <div class="accordion-content">
        <div>
          <span
            *ngIf="!model.delDescription && !disableFieldOnComplete()"
            class="icon-required-yellow"
          ></span>
          <span>Provide deliverable description</span>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="textarea-container">
              <div class="row padding-top-xs">
                <div class="col-12">
                  <dds-textarea
                    autosave
                    name="delDescription"
                    [disabled]="disableFieldOnComplete()"
                    [(ngModel)]="model.delDescription"
                    [label]="textareaOptions.label"
                    [labelPosition]="textareaOptions.labelPosition"
                    [placeholder]="textareaOptions.placeholder"
                    [description]="textareaOptions.description"
                    [minHeight]="textareaOptions.minHeight"
                    [isRequired]="textareaOptions.isRequired"
                    [customClass]="textareaOptions.customClass"
                    [isError]="textareaOptions.isError"
                    [errorMessage]="textareaOptions.errorMessage"
                    [errorState]="textareaOptions.errorState"
                    [maxLength]="textareaOptions.maxLength"
                    [maxLengthPosition]="textareaOptions.maxLengthPosition"
                    [size]="textareaOptions.size"
                    [readonly]="
                      isSubmissionInReadOnlyStatus() ||
                      !permissionObj['Intake_Submission_Deliverable_Enable']
                    "
                    (valueChanged)="deliverableDescValueChanged()"
                  ></dds-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #NotesFeedbackSection>
      <div class="accordion-content">
        <div
          class="notes-paragraph eclipse-content-grey padding-bottom-16"
          *ngIf="!isSubmissionStatusRMorSelfReviewed"
        >
          Use this field to (i) provide notes about any relevant history,
          unusual aspects, or unique characteristics of the engagement that
          reviewers should be aware of or (ii) view feedback from reviewers on
          the document
        </div>
        <span
          *ngIf="checkStatusCompletedByAdmin() || checkStatusDiscontinued()"
          class="padding-bottom-m"
        >
          <div class="sub-text-section margin-top-xs">
            <span class="icon-s icon-alert"></span>
            <span>
              <div
                *ngIf="checkStatusCompletedByAdmin()"
                class="eclipse-header-grey"
              >
                Submission admin closed
              </div>
              <div
                *ngIf="checkStatusDiscontinued()"
                class="eclipse-header-grey"
              >
                Submission Discontinued
              </div>
              <div
                class="vertical-line-green-s absolute padding-bottom-xxs"
                *ngIf="isShowMoreDocumentNotes"
              ></div>
            </span>
          </div>
          <div class="padding-left-m">
            <span>
              <div class="margin-top-xs" *ngIf="isShowMoreDocumentNotes">
                <div *ngFor="let history of submissionActionHistory">
                  <div
                    class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                  >
                    {{ history.resetedOn }} by
                    {{ history.resetedBy }}
                  </div>
                  <div
                    class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                  >
                    Reason: {{ history.reason }}
                  </div>
                  <div
                    *ngIf="checkStatusCompletedByAdmin()"
                    class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                  >
                    Additional details:
                    {{ history.additionalDetails }}
                  </div>
                </div>
              </div>
            </span>
            <dds-button
              class="showMoreCls"
              [theme]="showMoreOptions.theme ?? _EMPTY"
              [kind]="showMoreOptions.kind ?? _EMPTY"
              [size]="showMoreOptions.size ?? _EMPTY"
              [width]="showMoreOptions.width ?? _EMPTY"
              [icon]="showMoreOptions.icon ?? _EMPTY"
              [isIconLeft]="showMoreOptions.isIconLeft ?? false"
              [role]="showMoreOptions.role ?? _EMPTY"
              [ariaLabel]="showMoreText"
              [customClass]="showMoreOptions.customClass ?? _EMPTY"
              (clicked)="clickToShowDocumentMoreLepMessage()"
              >{{ showMoreText }}</dds-button
            >
          </div>
        </span>
        <span *ngIf="showResetActionMessage" class="padding-bottom-m">
          <div>
            <span>
              <div class="margin-top-xs">
                <div>
                  <div
                    class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                  >
                    <div>
                      Submission reset from
                      {{ resetActionMessage?.previousStatus }} to
                      {{ resetActionMessage?.currentStatus }} on
                      {{ resetActionMessage?.resetedOn }} by
                      {{ resetActionMessage?.resetedBy }}.
                    </div>
                    <div>
                      <span>Reason: {{ resetActionMessage?.reason }}</span>
                      <span
                        *ngIf="resetActionMessage?.otherReasonDescription"
                        class="padding-left-xs"
                        >{{ resetActionMessage?.otherReasonDescription }}</span
                      >
                    </div>
                  </div>
                </div>
              </div></span
            >
          </div>
        </span>
        <div>
          <div class="row">
            <div class="col-12">
              <div class="textarea-container">
                <div class="row">
                  <div class="col-12">
                    <dds-textarea
                      autosave
                      name="notesAndFeedback"
                      [(ngModel)]="model.notesAndFeedback"
                      [labelPosition]="textareaOptions.labelPosition"
                      [placeholder]="enter_text_placeholder"
                      [description]="textareaOptions.description"
                      [minHeight]="textareaOptions.minHeight"
                      [isRequired]="textareaOptions.isRequired"
                      [customClass]="textareaOptions.customClass"
                      [isError]="textareaOptions.isError"
                      [errorMessage]="textareaOptions.errorMessage"
                      [errorState]="textareaOptions.errorState"
                      [maxLength]="internalQrmCommunicationTextareaMaxlength"
                      [maxLengthPosition]="textareaOptions.maxLengthPosition"
                      [size]="textareaOptions.size"
                      [readonly]="
                        isSubmissionInReadOnlyStatus() ||
                        !permissionObj[
                          'Intake_Submission_NotesAndFeedback_Enable'
                        ]
                      "
                      (valueChanged)="feedbackInputValueChanged()"
                    ></dds-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #WorkflowSection>
      <div class="accordion-content">
        <div class="div-headers">
          <table class="dds-data-table dds-data-table_selection">
            <thead class="dds-data-table__header">
              <tr>
                <th
                  class="dds-data-table__header-cell"
                  *ngIf="
                    !isSubmissionInReadOnlyStatus() &&
                    permissionObj['Intake_Submission_WorkflowCheckbox_Visible']
                  "
                >
                  Required
                </th>
                <th
                  *ngFor="let column of riskManagerTableHeader"
                  class="dds-data-table__header-cell"
                  [ngStyle]="{
                    width: column.width,
                    minWidth: column.minWidth
                  }"
                >
                  <div class="dds-data-table__content">
                    <span>{{ column.header || column.name }}</span>
                  </div>
                </th>
                <th class="dds-data-table__header-cell">
                  <span>Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="dds-data-table__body">
              <tr
                *ngFor="let row of updatedRiskManagerDetails; index as index"
                class="dds-data-table__row"
              >
                <td
                  class="dds-data-table__cell table-checkbox-cell"
                  *ngIf="
                    !isSubmissionInReadOnlyStatus() &&
                    permissionObj['Intake_Submission_WorkflowCheckbox_Visible']
                  "
                >
                  <dds-checkbox
                    *ngIf="
                      (row.roleName === roleRiskManager &&
                        !showRiskManagerLabel) ||
                      (row.roleName === roleSupportingRiskManager &&
                        !showSupportingRiskManagerLabel) ||
                      (row.roleName === roleSpecializedRiskManager &&
                        !showSpecializedRiskManagerLabel) ||
                      row.roleName === roleTechnicalOrIndependentRM ||
                      row.roleName === roleAdditionalReviewer
                    "
                    class="custom-checkbox-class"
                    [ariaLabel]="'row ' + (index + 1)"
                    [value]="isReviewerCheckboxChecked(row.isRequired, index)"
                    theme="green"
                    [disabled]="isReviewerCheckboxDisabled(row.emailId, index)"
                    (click)="toggleRow(row.emailId, index)"
                  ></dds-checkbox>
                </td>
                <td class="dds-data-table__cell">
                  <div
                    *ngIf="
                      !row.isEditable || (row.isEditable && !row.isEditing);
                      else displayPeoplePicker
                    "
                  >
                    <span
                      class="comments-text-label eclipse-small-header-grey font-size-11 d-block"
                      >{{ row.roleName }}
                    </span>

                    <span class="profile-name d-inline-block">{{
                      row.displayName || row?.fullName || "N/A"
                    }}</span>

                    <ng-container *ngIf="row.isEditable">
                      <span
                        *ngIf="!disableFieldOnComplete()"
                        class="dds-icon dds-icon_edit__s__filled edit-icon"
                        [ngClass]="{
                          'pe-none opacity-50': isEditDeleteRowDisabled(
                            row.roleName
                          )
                        }"
                        (click)="
                          $event.stopPropagation();
                          editReviewer(
                            row.emailId,
                            row.submissionApproverId ?? -1,
                            row.isForTechnicalReviewer ?? false
                          )
                        "
                      ></span>
                      <span
                        class="margin-left-s dds-icon dds-icon_delete__l__stroke"
                        [ngClass]="{
                          'pe-none opacity-50': isEditDeleteRowDisabled(
                            row.roleName
                          )
                        }"
                        (click)="
                          $event.stopPropagation();
                          clearReviewer(row.emailId, row.isForTechnicalReviewer)
                        "
                      ></span
                    ></ng-container>
                  </div>
                  <ng-template #displayPeoplePicker>
                    <ng-container
                      *ngIf="
                        isEditingReviewer(row) ||
                        isEditingTechnicalReviewer(row)
                      "
                    >
                      <app-people-picker
                        [showLabel]="true"
                        [labelText]="
                          isEditingTechnicalReviewer(row)
                            ? roleTechnicalOrIndependentRM
                            : roleAdditionalReviewer
                        "
                        [isTechinalReviewerSearch]="
                          isEditingTechnicalReviewer(row) ? true : false
                        "
                        (userSelected)="
                          onMemberSelected(row.emailId, row.reviewerId, $event)
                        "
                        [id]="'picker-' + index"
                      ></app-people-picker>
                    </ng-container>
                  </ng-template>
                </td>
                <td class="dds-data-table__cell">
                  <!-- 
            TODO: Once Employee ID is implemented this needs to be checked
            <div
              *ngIf="
                loggedInEmployeeId === row.reviewerId &&
                submissionStatus === 'Submitted' &&
                row.statusReviewedDate === null
              "
              class="d-flex"
            > -->
                  <div
                    *ngIf="
                      showReviewAndReturnBtn &&
                      row.statusReviewedDate === null &&
                      row.reviewerId === currentLoggedInUser &&
                      permissionObj['Intake_Submission_WorkflowAction_Visible']
                    "
                    class="d-flex"
                  >
                    <dds-button
                      class="custom-button padding-right-xs"
                      [disabled]="
                        !permissionObj[
                          'Intake_Submission_WorkflowAction_Enable'
                        ] || !isOpporunityLevelFormCompleted
                      "
                      (clicked)="handleCompleteReview(row)"
                      >Complete review</dds-button
                    >

                    <dds-button
                      class="custom-button"
                      [kind]="primaryButtonOptions.kind ?? _EMPTY"
                      [disabled]="
                        !permissionObj[
                          'Intake_Submission_WorkflowAction_Enable'
                        ] || !isOpporunityLevelFormCompleted
                      "
                      (clicked)="handleReturnforRework(row)"
                      >Return for revisions</dds-button
                    >
                  </div>
                  <div *ngIf="row.statusReviewedDate !== null">
                    <div class="flex-row-col">
                      <p class="text-green-2">Review Completed</p>
                      <p class="review-status-date" class="review-status-date">
                        {{ row.statusReviewedDate }}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <dds-button
            *ngIf="
              !isSubmissionInReadOnlyStatus() &&
              permissionObj['Intake_Submission_WorkflowAddReviewer_Visible']
            "
            [theme]="options.theme ?? _EMPTY"
            [kind]="options.kind ?? _EMPTY"
            [size]="options.size ?? _EMPTY"
            [width]="options.width ?? _EMPTY"
            [icon]="options.icon ?? _EMPTY"
            [isIconLeft]="options.isIconLeft ?? false"
            [role]="options.role ?? _EMPTY"
            [isInverse]="options.isInverse ?? false"
            [isColorBg]="options.isColorBg ?? false"
            [isLoading]="options.isLoading ?? false"
            [ariaLabel]="options.ariaLabel ?? _EMPTY"
            [customClass]="'addreviewer-btn'"
            [disabled]="isAddReviewerButtonDisabled"
            (clicked)="
              $event.stopPropagation(); addReviewer(roleAdditionalReviewer)
            "
            >Add reviewer</dds-button
          >

          <div
            *ngIf="loggedUserReqdInWorkflowTable()"
            class="supress-notification-section"
          >
            <p
              class="eclipse-small-header-grey font-size-11 margin-bottom-xxs margin-top-s"
            >
              Review confirmation notification
            </p>
            <dds-checkbox
              autosave
              class="supress-notification-checkbox"
              label="
                Suppress review confirmation notification to the pursuit team
              "
              [ariaLabel]="'Suppress notification checkbox'"
              [(ngModel)]="model.isSuppressedReviewConfirmationNotification"
              [disabled]="isSubmissionInReadOnlyStatus()"
              theme="green"
            ></dds-checkbox>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #InternalQRMSection>
      <div class="accordion-content">
        <div>
          <div class="row">
            <div class="col-12">
              <div class="text-label eclipse-content-grey padding-bottom-s">
                Viewable by QRM team only. Purged one year after the final
                documents are archived
              </div>
              <div class="textarea-container">
                <div class="row">
                  <div class="col-12">
                    <dds-textarea
                      autosave
                      name="internalQRMTeamCommunication"
                      [(ngModel)]="model.internalQRMTeamCommunication"
                      [labelPosition]="textareaOptions.labelPosition"
                      [placeholder]="'Enter your comments'"
                      [description]="textareaOptions.description"
                      [minHeight]="textareaOptions.minHeight"
                      [isRequired]="textareaOptions.isRequired"
                      [customClass]="textareaOptions.customClass"
                      [isError]="textareaOptions.isError"
                      [errorMessage]="textareaOptions.errorMessage"
                      [errorState]="textareaOptions.errorState"
                      [maxLength]="internalQrmCommunicationTextareaMaxlength"
                      [maxLengthPosition]="textareaOptions.maxLengthPosition"
                      [size]="textareaOptions.size"
                      [readonly]="isInternalQRMDisabled"
                      (valueChanged)="
                        internalQrmCommunicationInputValueChanged()
                      "
                    ></dds-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #documentComponentTemplate let-contextData>
      <app-document
        [tableId]="contextData?.tableId"
        [submissionId]="submissionId"
        [submissionStatusId]="submissionStatusId"
        [submissionStatus]="submissionStatus"
        [submissionTypeId]="submissionTypeId"
        [submissionTypeCode]="submissionTypeCode"
        [submissionTypeSubId]="submissionTypeSubId"
        [permissionObj]="permissionObj"
        [opportunityDocs]="contextData?.opportunityDocs ?? []"
        [rmReviewedGuidanceNoteHeader]="rmReviewedGuidanceNoteHeader"
        [rmReviewedGuidanceNoteBody]="rmReviewedGuidanceNoteBody"
        [uploadAreaBtnLabel]="
          contextData?.uploadAreaBtnLabel ?? 'Select file(s)'
        "
        [selfReviewEligibilityStatusId]="selfReviewEligibilityStatusId"
        [optOutSelfReviewDate]="optOutSelfReviewDate"
        [selfReviewEligibilityStatus]="selfReviewEligibility"
        [optOutOfSelfReview]="optOutOfSelfReviewReason"
        [isDraftForSelfReview]="isSelfReviewButtonVisible"
        [isDocSectionEditable]="contextData?.isDocSectionEditable ?? true"
        [showDocumentTable]="contextData?.showDocumentTable ?? true"
        [showDragNDropArea]="contextData?.showDragNDropArea ?? true"
        [showAddLinkBtn]="contextData?.showAddLinkBtn ?? true"
        [showToggleBtn]="contextData?.showToggleBtn ?? true"
        [toggleOpen]="contextData?.toggleOpen ?? false"
        [showArchiveColumn]="contextData?.showArchiveColumn ?? false"
        [filterDocArr]="contextData?.filterDocArr ?? []"
        [currentStatusChangeDate]="currentStatusChangeDate"
        [otherSubmissionSubType]="
          submissionTypeCode === submissionTypeCodeOther
            ? getSubmissionSubType(model.submissionSubTypeId)
            : _EMPTY
        "
        (documentTableData)="
          handleDocumentTableData($event, contextData?.tableId)
        "
      ></app-document>
    </ng-template>

    <ng-template #swapActionSelectionForPendingCloseout>
      <div class="text-align-left margin-top-m">
        <p class="font-size-16 font-bold-600 line-height-m">Select Action:</p>
        <div class="d-flex align-items-center gap-3">
          <dds-button
            class="custom-button"
            [theme]="primaryButtonOptions.theme ?? _EMPTY"
            [kind]="primaryButtonOptions.kind ?? _EMPTY"
            [size]="primaryButtonOptions.size ?? _EMPTY"
            [width]="primaryButtonOptions.width ?? _EMPTY"
            [ariaLabel]="swapReviewedDocResubmit"
            [ddsTooltip]="reviewDocSubmitTooltip"
            [tooltipInvokeType]="tooltipOptions.tooltipInvokeType ?? ''"
            [tooltipType]="tooltipOptions.tooltipType ?? ''"
            [tooltipSize]="tooltipOptions.tooltipSize ?? ''"
            [tooltipPosition]="tooltipOptions.tooltipPosition ?? ''"
            [tooltipIndent]="tooltipOptions.tooltipIndent ?? 0"
            [tooltipHasBeak]="tooltipOptions.tooltipHasBeak ?? false"
            [tooltipTheme]="tooltipOptions.tooltipTheme ?? ''"
            [tooltipMaxWidth]="tooltipOptions.tooltipMaxWidth ?? 0"
            (clicked)="swapSectionSelected(swapReviewedDocResubmit)"
            >{{ swapReviewedDocResubmit }}</dds-button
          >
          <dds-button
            class="custom-button"
            [theme]="primaryButtonOptions.theme ?? _EMPTY"
            [kind]="primaryButtonOptions.kind ?? _EMPTY"
            [size]="primaryButtonOptions.size ?? _EMPTY"
            [width]="primaryButtonOptions.width ?? _EMPTY"
            [ariaLabel]="swapArchiveFinalize"
            [ddsTooltip]="archiveFinalizeTooltip"
            [tooltipInvokeType]="tooltipOptions.tooltipInvokeType ?? ''"
            [tooltipType]="tooltipOptions.tooltipType ?? ''"
            [tooltipSize]="tooltipOptions.tooltipSize ?? ''"
            [tooltipPosition]="tooltipOptions.tooltipPosition ?? ''"
            [tooltipIndent]="tooltipOptions.tooltipIndent ?? 0"
            [tooltipHasBeak]="tooltipOptions.tooltipHasBeak ?? false"
            [tooltipTheme]="tooltipOptions.tooltipTheme ?? ''"
            [tooltipMaxWidth]="tooltipOptions.tooltipMaxWidth ?? 0"
            (clicked)="swapSectionSelected(swapArchiveFinalize)"
            >{{ swapArchiveFinalize }}</dds-button
          >
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
